import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CurrentUserState {
    isTnUser: boolean;
}

export const initialState: CurrentUserState = {
    isTnUser: false,
};

const slice = createSlice({
    name: 'current-user',
    initialState: initialState,
    reducers: {
        setTnUser: (draft: CurrentUserState, action: PayloadAction<boolean>) => {
            draft.isTnUser = action.payload;
        },
    },
});

export const actions = slice.actions;

export default slice.reducer;